<template>
  <div class="filters">
    <div class="accent--text mb-5 text-h6">
      <v-icon size="20" left color="accent" class="vertical-align-text-top"
        >mdi-filter</v-icon
      >
      Filters
    </div>
    <v-select
      clearable
      v-model="status"
      label="Request Status"
      dense
      item-text="label"
      item-value="value"
      :items="selectItems.proposal_status"
      outlined
    ></v-select>
    <v-text-field
      type="number"
      min="0"
      max="100"
      v-model="validated_percent__gte"
      label="Min validated percentage value"
      outlined
    ></v-text-field>
    <v-text-field
      type="number"
      min="0"
      max="100"
      v-model="validated_percent__lte"
      label="Max validated percentage value"
      outlined
    ></v-text-field>
  </div>
</template>

<script>
import { capitalize, debounce } from "lodash"
import { PROPOSAL_STATUS } from "@/data"
export default {
  components: {},
  data() {
    return {
      selectItems: {
        proposal_status: Object.keys(PROPOSAL_STATUS)
          .filter(k => !["CANCELLED"].includes(k))
          .map(k => ({
            value: PROPOSAL_STATUS[k],
            label: capitalize(PROPOSAL_STATUS[k])
          }))
      }
    }
  },
  computed: {
    status: {
      get() {
        return this.$store.state.brandsFilters.status
      },
      set(v) {
        this.$store.commit("setBrandsFiltersValue", {
          attr: "status",
          value: v
        })
      }
    },
    validated_percent__gte: {
      get() {
        return this.$store.state.brandsFilters.validated_percent__gte
      },
      set: debounce(function(v) {
        if (v !== this.$store.state.brandsFilters.validated_percent__gte) {
          if (v > 100) {
            v = 100
          }
          this.$store.commit("setBrandsFiltersValue", {
            attr: "validated_percent__gte",
            value: v
          })
        }
      }, 500)
    },
    validated_percent__lte: {
      get() {
        return this.$store.state.brandsFilters.validated_percent__lte
      },
      set: debounce(function(v) {
        if (v !== this.$store.state.brandsFilters.validated_percent__lte) {
          if (v > 100) {
            v = 100
          }
          this.$store.commit("setBrandsFiltersValue", {
            attr: "validated_percent__lte",
            value: v
          })
        }
      }, 500)
    }
  }
}
</script>

<style lang="scss" scoped></style>
